import { useEffect, useState, useRef } from 'react';
import { wsProxy } from '@/services';
import RIWebSocket from '@/utils/socket';
import useSession from '@/hooks/useSession';
import alarm from '@/utils/alarm';

export const ON_WALL_TIMERANGE = 15 * 1000;

export interface ICameraData {
  eventId: string;
  deviceId: string | number;
  deptName: string;
  nodeName: string;
  rtsp: string;
  attentionLevel: number;
  timestamp: number;
  timeCondition: number;
  season: string;
  url: string;
  displayName: string;
  flvUrl: string;
  timeRange?: string;
  rules?: any[];
}

export interface IRealtimeCamera {
  deviceId: string | number;
  flvUrl: string;
  noVoice?: boolean;
  camName?: string;
  displayName?: string;
}

export default () => {
  const [freshList, setFreshList] = useState('');
  const [heatFresh, setHeatFresh] = useState('');
  const [freshListNoVoice, setFreshListNoVoice] = useState('');
  const [freshDetailId, setFreshDetailId] = useState('');
  const [timeOffset, setTimeOffset] = useState(0);
  const [cameraQueue, setCameraQueue] = useState<ICameraData[]>([]);
  const [cameraStatus, setCameraStatus] = useState<ICameraData[]>([]);
  const [realtimeCameras, setRealtimeCameras] = useState<IRealtimeCamera[]>([]);
  const [camera, setCamera] = useState<ICameraData | null>(null);
  const socketRef = useRef<RIWebSocket>(undefined);
  const timeOffsetRef = useRef(0);
  const { sessionId } = useSession();

  const handleMessage = (
    {
      msgId,
      report,
      data,
    }: {
      msgId: string;
      report: string;
      data: any;
    } = { msgId: '', report: '', data: {} },
  ) => {
    // TODO vicky
    if (report === 'business.pong') {
      const t = new Date().valueOf() - data;
      setTimeOffset(t);
      timeOffsetRef.current = t;
    } else if (report === 'business.event.fresh.list') {
      setFreshList(msgId);
    } else if (report === 'xfx.ws.regional.refresh') {
      setHeatFresh(msgId);
    } else if (report === 'business.event.Fresh.NoVoice') {
      setFreshListNoVoice(msgId);
    } else if (report === 'business.event.top.cameras.update') {
      const adaptedData = typeof data === 'string' ? JSON.parse(data) : data;
      setCameraQueue(adaptedData);
      if (Array.isArray(adaptedData)) {
        adaptedData
          .filter(
            (camera) =>
              // eslint-disable-next-line eqeqeq
              camera.soluteType != 1 &&
              camera.noVoice !== true &&
              Date.now() - camera.timestamp - timeOffsetRef.current < ON_WALL_TIMERANGE,
          )
          .forEach((camera) => {
            alarm.play(`${camera.camName}发生${camera.displayName}`, sessionId);
          });
      }
    } else if (report === 'business.realtime.cameras.update') {
      const adaptedData = typeof data === 'string' ? JSON.parse(data) : data;
      setRealtimeCameras(Array.isArray(adaptedData) ? adaptedData : []);
    } else if (report === 'business.event.cam.current.status') {
      setCameraStatus(typeof data === 'string' ? JSON.parse(data) : data);
    } else {
      console.info('receive message', msgId, report, data);
    }
    // } else if (report === 'business.event.fresh.all') {
    //   store.dispatch('websocket/setFreshAll', msgId);
  };

  const initWebSocket = () => {
    socketRef.current?.closeWebSocket();
    socketRef.current?.connectWebSocket();
  };

  const closeWebSocket = () => {
    socketRef.current?.closeWebSocket();
  };

  const fetchCameraStatus = (deviceIds: (string | number)[] = []) => {
    socketRef.current?.getListCameraStatus(deviceIds);
  };

  const sendStreamFlvPing = (flvUrl: string) => {
    socketRef.current?.sendStreamFlvPing(flvUrl);
  };

  useEffect(() => {
    socketRef.current = new RIWebSocket(wsProxy, handleMessage);
  }, []);

  return {
    timeOffset,
    freshList,
    heatFresh,
    freshListNoVoice,
    freshDetailId,
    camera,
    cameraQueue,
    cameraStatus,
    realtimeCameras,
    fixedRealtimeCamera: realtimeCameras[0],
    setFreshDetailId,
    setCamera,
    fetchCameraStatus,
    sendStreamFlvPing,
    initWebSocket,
    closeWebSocket,
  };
};
